<template>
  <uiDialog
    v-if="props.isVisible"
    :isVisible="props.isVisible"
    :style="{ width: props.width, height: props.height }"
    :closeBtn="true"
    :whiteBtn="true"
    @onClose="dialogCloseHandler"
  >
    <article class="alert-container" ref="dialogContainer">
      <!-- <header class="alert-header">
                <p class="title22__highlight gradient" style="text-align: center;">
                    Preview
                </p>
            </header> -->
      <section class="alert-body">
        <component :is="viewPage" class="insert-content"></component>
        <!-- <div class="btn-wrap">
          <button
            class="btn-linear sentence sentence__600"
            @click="dialogCloseHandler"
          >
            {{ $t(btnName) || $t("chart1.popupClose") }}
          </button>
        </div> -->
      </section>
    </article>
  </uiDialog>
</template>

<script setup>
/**
 * 사용하실 페이지에서 vue 파일 import 하신 후 viewPage에 담아주시면 됩니다.
 *
 * 회색 i 아이콘은
*   <div style="display: inline-block;">
        <img class="tooltip-gap" src="@/assets/images/icons/tooltip-ico.svg" alt="">
    </div>
 * 이거 적으시면 바로 나옵니다! (참고: after.scss)
 *
 * (예시)
 *  [부모 컴포넌트]
 *  <div @click=showPop('key값')>
 *       <ui-dialog-ExplainContent
            v-for="(dialog, key) in dialogs"
            :key="key"
            :width="dialog.width"
            :height="dialog.height"
            :title="dialog.title"
            :btnName="dialog.btnName"
            :isVisible="dialog.visible"
            :viewPage="dialog.viewPage"
            @onDialogClose="closeCopyDialog(key)"
        />
 * import PageAlgorithm from '@/pages/kibot/algorithm.vue';
 * const dialogs = ref({
    explainContent: {
        width: '80%',
        height: '100rem',
        title: 'Notice',
        btnName: 'Close',
        visible: false,
        viewPage: PageAlgorithm,
    },
    tototo: {
        width: '80%',
        height: '100rem',
        title: 'Notice',
        btnName: 'Close',
        visible: false,
        viewPage: PageAlgorithm,
    },
});

const showPop = (key) => {
    dialogs.value[key].visible = true;
};

const closeCopyDialog = (key) => {
    dialogs.value[key].visible = false;
};
 */
import uiDialog from "@/components/ui/Dialog.vue";
import { ref, watch, defineEmits, defineProps } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

const emit = defineEmits(["onDialogClose"]);
const props = defineProps({
  title: String,
  btnName: String,
  width: String,
  height: String,
  isVisible: Boolean,
  viewPage: String,
});

const dialogCloseHandler = () => {
  emit("onDialogClose", {
    isVisible: false,
  });
};

const dialogContainer = ref(null);

const initializeAOS = () => {
  AOS.init({ disable: true });
  AOS.refreshHard();
};

// 다이얼로그가 열릴 때 AOS 초기화
watch(
  () => props.isVisible,
  (newVal) => {
    if (newVal) {
      initializeAOS();
    }
  }
);

// 다이얼로그 내에서 스크롤 시 AOS 리프레시
// const handleScroll = () => {
//     AOS.refresh();
//     console.log('refresh');
// };

// onMounted(() => {
//     if (dialogContainer.value) {
//         dialogContainer.value.addEventListener('scroll', handleScroll);
//     }
// });

// onBeforeUnmount(() => {
//     if (dialogContainer.value) {
//         dialogContainer.value.removeEventListener('scroll', handleScroll);
//     }
// });
</script>

<style scoped>
@import "@/assets/scss/components/ui/dialog/alert.scss";
@import "@/assets/scss/components/ui/dialog/explaincontent.scss";
:deep(.common-container) {
  padding: 0;
}
</style>
